import { EnumOperator } from '../../../../../../api/com/MetaPattern/Core/Infrastructure/Exp/EnumOperator';
import { EnumConnector } from '../../../../../../api/com/MetaPattern/Core/Infrastructure/Exp/EnumConnector';
import { Condition } from './Condition';
import { SubCondition } from './SubCondition';

export class ConditionItem {
  key: string;
  value: string;
  operator: EnumOperator;
  connector: EnumConnector;
  condition: Condition;
  subCondition: SubCondition;
}
